import OverloadRelays from "../classes/OverloadRelay"
import { Position } from 'reactflow';

export const overloadRelays = [
  /*new OverloadRelays({
    alias:"resistencia-a-tierra", 
    svgSrc: "/symbol-assets/ResistenciaATierra.svg", 
    label: "Resistencia a tierra",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),*/
  new OverloadRelays({
    alias:"reactor-a-tierra", 
    svgSrc: "/symbol-assets/ReactorATierra.svg", 
    label: "Banco de reactores",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),
  new OverloadRelays({
    alias:"banco-de-capacitadores", 
    svgSrc: "/symbol-assets/BancoDeCapacitores.svg", 
    label: "Banco de capacitadores",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),
  new OverloadRelays({
    alias:"filtro-de-armonicos-a", 
    svgSrc: "/symbol-assets/FiltroDeArmonicosSimbolo1.svg", 
    label: "Banco de filtros armónicos",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),
  new OverloadRelays({
    alias:"filtro-de-armonicos-b", 
    svgSrc: "/symbol-assets/FiltroDeArmonicosSimbolo1B.svg", 
    label: "Banco de filtros armónicos",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),
];
